<template>

  <div class="PayBill">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Pay Electricity Bill</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Pay Your Electricity Bill</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
           <br>
          <!-- <p style="color:red;">
          We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.
        </p> -->

        <b-row>
               <b-col col cols="5" sm="5" md="2" lg="2" style="padding-top: 7px;">
                     <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
               </b-col>
               <b-col col cols="7" sm="7" md="3" lg="3" style="padding-top: 5px;">
                   <b-form-input type="number" maxlength="12" id="consNo" value=""  placeholder="Enter Consumer Number" trim required />
               </b-col>

               <b-col col cols="5" sm="5" md="3" lg="2" style="padding-top: 5px;" >
                <img id="captcha" src="#" alt="captcha">
                <a href="#" @click="generateCaptcha()" ><b-icon icon="arrow-clockwise" font-scale="1.8" style="padding-top:7px"></b-icon></a>
              
              </b-col>
              <b-col col cols="4" sm="4" md="2" lg="2" style="padding-top: 5px;">
                  <b-form-input type="number" id="result" placeholder="Answer" style="padding-top: 7px;" />
              </b-col> 
              
               <b-col col cols="3" sm="3" md="2" lg="1" style="padding-top: 5px;">
                      <b-button @click="checkConsumerType()" block pill variant="primary" size="md" class="go" style="width:100%"> 
                     
                       <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                     </b-button>

               </b-col>
          </b-row>
    <br>
    <div id="BillDetails" class="billDetails">
          <b-row>
            <b-col cols=12>
                <span class="heading">Bill Summary</span>
            </b-col>
          </b-row>
          <hr/>
           <b-row class="paddingRow">
             <b-col cols="12" sm="6" md="6" lg="6">
               <span class="label">Consumer Name: </span>
               <span class="" id="consName"></span>
             </b-col>
             <b-col cols="12" sm="6" md="6" lg="6">
               <span class="label">Subdivision: </span>
               <span class="" id="subDiv"></span>
             </b-col>
             <!-- <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol displayProp">
               <span class="label">  Mobile No<span class="text-danger">*</span>:  </span>
               <b-form-input type="number" id="mobileNo" class="inputWidth" placeholder="Mobile No" trim />
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol displayProp">
               <span class="label"> Email ID:  </span>
               <b-form-input type="email" id="emailId" class="inputWidth" placeholder="Email ID" trim />
             </b-col> -->
           </b-row>
           <b-row class="">
             <b-col col cols="12" sm="12" md="12" lg="12">
               <b-table responsive bordered   :items="consumerBill" :fields="consumerBillFields">
                   <template v-slot:cell(bill_type)="data">
                     <span   v-html="data.value"></span>
                  </template>
                  <template v-slot:cell(bill_no)="data">
                    <span   v-html="data.value"></span>
                 </template>
                 <template v-slot:cell(bill_date)="data">
                   <span   v-html="data.value"></span>
                </template>
                  <template v-slot:cell(due_date)="data">
                    <span   v-html="data.value"></span>
                 </template>
                  <template v-slot:cell(bill_amt)="data">
                    <span   v-html="data.value"></span>
                 </template>
               </b-table>
               </b-col>
           </b-row>
           <b-row class="paddingRow">
             <b-col cols="12" sm="4" md="4" lg="4" class="paddingCol displayProp">
               <span class="label" style="padding-right: 10px;">  Mobile No <span class="text-danger">*</span></span>
               <b-form-input type="number" id="mobileNo" class="inputWidth" placeholder="Mobile No" trim />
             </b-col>
             <!-- <b-col cols="12" sm="4" md="4" lg="4" class="paddingCol displayProp">
               <span class="label" style="padding-right: 10px;"> Email ID </span>
               <b-form-input type="email" id="emailId" class="inputWidth" placeholder="Email ID" trim />
             </b-col> -->
             <b-col cols="12" sm="3" md="3" offset-md="1" lg="3" offset-lg="1">
               <b-button block squared variant="primary" class="marginTop" @click="payNow()">
                <b-icon icon="credit-card" animation=""  >  </b-icon> PAY NOW
              </b-button>
             </b-col>
           </b-row>
          </div>
      </div>
  </b-container>

  <b-container id="billdeskRequestDiv" fluid style="padding-top: 100px;text-align:left;display:none">

    <br><br>
  <b-row id="spinner" style="display:block">
    <b-col cols=12 align="center">
      <h3 class="">Processing Payment Request...</h3>
      <br><br>
        <b-spinner style="width: 10rem; height: 10rem;" variant="primary" label="Spinning"></b-spinner>
      <br><br><br>
     <h5 style="color:red">Please do not press back or refresh button</h5>
  </b-col>
  </b-row>
  <b-row id="errorDiv" style="display:none">
    <b-col cols=12 align="center">
    <h2 style="color:red" id="errorMsg"></h2>
      <br><br>
    <b-button onclick="window.location.reload();">Go Back</b-button>
    </b-col>
  </b-row>
</b-container>
<br><br>
</b-overlay>
<form :action = "reqUrl" method="post" id="pgrequest" hidden>
    <input type="" name="msg" :value = "messageToSend" hidden >
    <input type="submit" id="submit" value="submit" hidden>
</form>
    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="msg" >  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="holdingModal" centered  scrollable title="ATTENTION !" :static="true" hide-footer   no-close-on-esc
      no-close-on-backdrop>
      <div  style="background-color: #fffec49e;padding:1rem">
      <span class="" id="msg" style="color:#e64a19;font-size:1.05rem;font-weight:600">
        Dear Consumer, You are requested
        to link your Holding Number with APDCL Consumer Number.
        <br>Ignore if already updated. </span>
      <br><br>
      <a href="HoldingNoUpdate" class="blink_me">Click Here to Link Your Holding Number</a>
      <br><br>
         <b-button  style="" variant="outline-primary" @click="closeModalH()">
           SKIP AND PROCEED TO PAY
         </b-button>
       </div>
    </b-modal>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

var consNo="";
var sdCode="";
var thColor = '#0288d1';
var isGmcCons ="";
var fetchHolding = "";
var result = "";
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      consumerNo: '',
      show: false,
      message : [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
      messageToSend:"",
      reqUrl:"",
      consumerBillFields: [
      { key: 'bill_type', label: 'Bill Type',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'}, thClass:'paddingTh', tdClass:'paddingTd'},
      { key: 'bill_no', label: 'Bill Number',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'}, thClass:'paddingTh', tdClass:'paddingTd'},
      { key: 'bill_date', label: 'Bill Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'}, thClass:'paddingTh', tdClass:'paddingTd'},
      { key: 'due_date', label: 'Due Date',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'}, thClass:'paddingTh', tdClass:'paddingTd'},
      { key: 'bill_amt', label: 'Bill Amount',thStyle: {width: '5vw',fontSize:"0.8rem",backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px',textAlign:''}, thClass:'paddingTh', tdClass:'paddingTd'}
    ],
    consumerBill : []

    }
  },
  methods: {
    generateCaptcha()
    {
      axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
                // console.log("captchaImage:::"+response.data);
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    })
    },
    
    checkConsumerType()
    {
         
      var consNo = document.getElementById("consNo").value;
         var config = {
                method: 'post',
                url: this.$urlRestapi+'/RestAPI/checkConsumerType',
                headers: {
                  'Content-Type': 'text/plain'
                },
                data : consNo
              };
              var parent=this;
              parent.show= true;
              axios(config)
              .then(function (response) {
                
                parent.show= false;
                console.log(response.data);
                if(response.data=="smartPrePaid")
                {
                  var msgToShow="This is a Smart Prepaid Consumer.<br> <a href='RechargePrepaid' style='text-decoration:underline;font-size:1.4rem'>Click Here</a> to Smart Prepaid Recharge"
                  document.getElementById("msg").innerHTML=msgToShow;
                  parent.$bvModal.show("model");
                  document.getElementById("BillDiv").classList.remove("showDetails");
                }
               else if(response.data=="prePaid")
                {
                  var msgToShow="This is a Prepaid Consumer.<br> <a href='RechargePrepaid' style='text-decoration:underline;font-size:1.4rem'>Click Here</a> to Prepaid Recharge"
                  document.getElementById("msg").innerHTML=msgToShow;
                  parent.$bvModal.show("model");
                  document.getElementById("BillDiv").classList.remove("showDetails");
                }
                else 
                {
                 parent.showDetails();
                }
                
              });
            
    },
  showDetails() {
 
    consNo = document.getElementById("consNo").value;
    if (consNo.toString().length!=12)
        {
          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }
       var result = document.getElementById("result").value;
      if ((result==""))
           {
             this.$bvToast.toast('Enter Captcha !', {
               title: `Alert`,
               variant: 'danger',
               solid: true
             })
             return;
           }  


     const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","023","025","030","093","094","122","123","124","147","148","151","170","171","173","207","208","209"];
    //const sdList=["001","002","003","004","005","006","009","010","011","013","014","015","016","017","023","025","030"];

      var sdCode=consNo.substring(0,3);
      console.log("sdCode:::"+sdCode);
      isGmcCons = sdList.includes(sdCode);
      console.log("isGmcCons:::"+isGmcCons)
          
      if(isGmcCons){
        fetchHolding ="y";
        }
        else{
          fetchHolding ="n";
        }
       
        var parent=this;
          this.show= true;
          parent.consumerBill=[];
        //  axios.post(this.$urlArms+'/RestAPI/OnlinePayment/consBillDetailsBilldesk?consumerNo='+consNo)
        //axios.post('https://uat.apdclrms.com/onlinepayment/RestAPI/OnlinePayment/consBillDetailsBilldesk?consumerNo='+consNo)
        axios.get(this.$urlCommon+'/api/web/energyBillPayment/getConsDetails?consNo='+consNo+'&result='+result+'&fetchHolding='+fetchHolding)
          .then((response) => {
            parent.show=false;
            //console.log(response.data);

            var data=response.data.data;
            var msg=response.data.message;
            
            
            if(msg=="00") {

              if(isGmcCons)
              { 
                var holdingData = response.data.holdingData;
                              
                  if(holdingData == "Consumer Not Found")
                  {
                    document.getElementById("BillDetails").classList.remove("showBillDetails");
                    parent.$bvModal.show("holdingModal");
                  
                  }
                  
                   {
                    var res=data.due_date.split("-");
                    var dueDate= res[2]+"-"+res[1]+"-"+res[0];

                    var bdate=data.bill_date.split("-");
                    var billDate=bdate[2]+"-"+bdate[1]+"-"+bdate[0];

                    var rddate= '';
                    var rcdcDate= '';

                    if(data.rcdc_charge>0){
                      rddate=data.rcdc_bill_date.split("-");
                      rcdcDate=rddate[2]+"-"+rddate[1]+"-"+rddate[0];
                    }
                    else{
                      rcdcDate="-";
                    }

                    sdCode = data.sd_code;
                    document.getElementById("consName").innerHTML=data.cons_name;
                    document.getElementById("subDiv").innerHTML=data.sd_name;
                    var tot = data.rcdc_charge+data.due_amount;
                    parent.show= false;
                    document.getElementById("BillDetails").classList.add("showBillDetails");
                    var enrgyObj={bill_type: '<div class="mobileFont">Energy Bill Details</div>',bill_no:'<div class="mobileFont">'+data.bill_no+'</div>',bill_date: '<div class="mobileFont">'+billDate+'</div>', due_date:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem;'>"+dueDate+"</div>", bill_amt: "<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.due_amount+"</div>"};
                    var rcObj={bill_type: '<div class="mobileFont">RC/DC Bill Details</div>',bill_no:'<div class="mobileFont">'+data.rcdc_bill_no+'</div>', bill_date: '<div class="mobileFont">'+rcdcDate+'</div>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.rcdc_charge+"</div>"}
                    var totObj={due_date: '<span class="mobileFont" style="font-weight: 600;">Total Payable Amount:</span>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+tot+"</div>"}

                    if(data.rcdc_charge>0){
                      parent.consumerBill.push(enrgyObj);
                      parent.consumerBill.push(rcObj);
                      parent.consumerBill.push(totObj);
                    }
                    else{
                      parent.consumerBill.push(enrgyObj);
                    }

                 document.getElementById("BillDetails").classList.add("showBillDetails");
                  }
               

              }
              else{
                parent.show= false;

                            var res=data.due_date.split("-");
                            var dueDate= res[2]+"-"+res[1]+"-"+res[0];

                            var bdate=data.bill_date.split("-");
                            var billDate=bdate[2]+"-"+bdate[1]+"-"+bdate[0];

                            var rddate= '';
                            var rcdcDate= '';

                            if(data.rcdc_charge>0){
                              rddate=data.rcdc_bill_date.split("-");
                              rcdcDate=rddate[2]+"-"+rddate[1]+"-"+rddate[0];
                            }
                            else{
                              rcdcDate="-";
                            }

                            sdCode = data.sd_code;
                            document.getElementById("consName").innerHTML=data.cons_name;
                            document.getElementById("subDiv").innerHTML=data.sd_name;
                            var tot = data.rcdc_charge+data.due_amount;
                            parent.show= false;
                            document.getElementById("BillDetails").classList.add("showBillDetails");
                            var enrgyObj={bill_type: '<div class="mobileFont">Energy Bill Details</div>',bill_no:'<div class="mobileFont">'+data.bill_no+'</div>',bill_date: '<div class="mobileFont">'+billDate+'</div>', due_date:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem;'>"+dueDate+"</div>", bill_amt: "<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.due_amount+"</div>"};
                            var rcObj={bill_type: '<div class="mobileFont">RC/DC Bill Details</div>',bill_no:'<div class="mobileFont">'+data.rcdc_bill_no+'</div>', bill_date: '<div class="mobileFont">'+rcdcDate+'</div>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+data.rcdc_charge+"</div>"}
                            var totObj={due_date: '<span class="mobileFont" style="font-weight: 600;">Total Payable Amount:</span>', bill_amt:"<div class='mobileFont' style='font-weight: 600;color: #ff5722;font-size: 1.1rem; text-align: left;'>"+tot+"</div>"}

                            if(data.rcdc_charge>0){
                              parent.consumerBill.push(enrgyObj);
                              parent.consumerBill.push(rcObj);
                              parent.consumerBill.push(totObj);
                            }
                            else{
                              parent.consumerBill.push(enrgyObj);
                            }

                   document.getElementById("BillDetails").classList.add("showBillDetails");
                   }
            }
       /*       else if(msg=="01") {
                     var config = {
                method: 'post',
                url: parent.$urlCommon+'/api/web/checkSPConversion',
                headers: {
                  'Content-Type': 'text/plain'
                },
                data : consNo
              };
              axios(config)
              .then(function (response) {
                parent.show= false;
                console.log(response.data);
                if(response.data=="True")
                {
                  var msgToShow="Consumer Converted to Smart Prepaid.<br> <a href='RechargePrepaid'>Click here to recharge</a>"
                  document.getElementById("msg").innerHTML=msgToShow;
                  parent.$bvModal.show("model");
                  document.getElementById("BillDetails").classList.remove("showBillDetails");
                }
                else
                {
                  
                  document.getElementById("msg").innerHTML=parent.message[parseInt(msg)];
                  parent.$bvModal.show("model");
                  document.getElementById("BillDetails").classList.remove("showBillDetails");
                }
              });
           
            }
            */
           else if(msg=="captcha_incorrect")
            {
              parent.$bvToast.toast('Invalid Captcha ! Please try again', {
                   title: `Alert`,
                   variant: 'danger',
                   solid: true
                 });
                 document.getElementById("BillDetails").classList.remove("showBillDetails");
                 document.getElementById("result").value="";
                 document.getElementById("result").focus();
             //    parent.generateCaptcha();                   
              return;
            }
            else
            {
              parent.show= false;
              parent.$bvModal.show("model");
              document.getElementById("msg").innerHTML=this.message[parseInt(msg)];
              document.getElementById("BillDetails").classList.remove("showBillDetails");
              
            }
            parent.generateCaptcha();
          })
          .catch((e) => {
          console.log("Caught", e);
          parent.show= false;
          parent.$bvModal.show("model");
          document.getElementById("msg").innerHTML="Sorry, Consumer / Bill not Found";
          document.getElementById("BillDetails").classList.remove("showBillDetails");
          parent.generateCaptcha();
        })


      },

    payNow()
    {
      var mobileNo = document.getElementById("mobileNo").value;
     // var emailId = document.getElementById("emailId").value;

      if (mobileNo.length!=10)
          {
            this.$bvToast.toast('Enter 10 Digit Mobile Number !', {
              title: `Alert`,
              variant: 'danger',
              solid: true
            })
            document.getElementById("mobileNo").focus();
            return
          }
          
    // axios.post( "https://www.apdcl.org/restapi/RestAPI/website/consDetailsUpdateFromEasyPay?consNo="+consNo+"&mobNo="+mobileNo)
    // .then((response) => {
    //   console.log(response.data);
    // })
    document.getElementById("consBillDiv").style.display="none";
    document.getElementById("billdeskRequestDiv").style.display="block";
    var parent= this;
    axios.post( this.$urlCommon+'/api/onlinepostpaid/pgrequest?consNo='+consNo+'&subDiv='+sdCode)
    .then((response) => {
      console.log(response.data);
      var data=response.data;
      var msg=response.data.message;

      if(msg=="00") {
        parent.reqUrl = data.action;
        parent.messageToSend= data.msg;
        setTimeout(function(){ document.getElementById("submit").click(); }, 2000);
      }
      else
      {
        document.getElementById('spinner').style.display = 'none';
        document.getElementById('errorDiv').style.display = 'block';
        document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
        this.$bvModal.show("model");
        document.getElementById("msg").innerHTML=this.message[parseInt(msg)];
        //document.getElementById("BillDetails").classList.remove("showBillDetails");
      }

    })
    .catch((e) => {
      parent.show= false;
      parent.$bvModal.show('model');
      document.getElementById("msg").innerHTML="Sorry, Please Try Again Later";
      console.log("Caught :::::::::::::::", e.message);

  })

    },
    closeModal(){
      this.$bvModal.hide('model')
    },
    closeModalH(){
      this.$bvModal.hide('holdingModal')
    }
  },
  mounted()
  {
    axios.post(this.$urlCommon+"/api/web/getCaptcha").then(function(response) {
               
                document.getElementById("captcha").src= "data:image/png;base64,"+response.data;

    })
  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

.blink_me {
  animation: blinker 1s linear infinite;
  font-weight:600;
}

@keyframes blinker {
  50% {
    /* color:red; */
     opacity: 0;
  }
}
.data{
  font-weight:600;
  color: #ff5722;
  font-size: 1.2rem;
}
/deep/ .table > tbody > tr > td {
  padding: 0.20rem !important;
}
/deep/ .table > tbody > tr > th {
  padding: 0.20rem !important;
}
max-width: 300px;
.paddingTh{
  padding: 0.20rem !important;
}
.paddingTd{
  padding: 0.20rem !important;
}
.displayProp{
  display: -webkit-box;
}
.inputWidth{
  width:75%;
  margin-top: -6px;
}
.paddingRow{
  padding:0.7rem;
}
.paddingLeft{
  padding-left: 0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.billDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showBillDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}
.marginTop{
  margin-top: -8px;
}
@media (max-width: 768px) {
/deep/ .mobileFont{
    font-size: 12px !important;
  }
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
    .displayProp{
      display: block;
    }
    .inputWidth{
      width:100%;
      margin-top: 0px;
    }
    .marginTop{
      margin-top: 22px;
    }
    /* .paddingCol{
      padding: 0.7rem;
    } */
  }
@media only screen and (max-width: 414px) {
/deep/ .mobileFont{
    font-size: 12px !important;
  }
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
  .displayProp{
    display: block;
  }
  .inputWidth{
    width:100%;
    margin-top: 0px;
  }
  .marginTop{
    margin-top: 0px;
  }
}

</style>
